define('ims/config',["exports", "core/pubsubhub", "ims/utils"], function (exports, _pubsubhub, _utils) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.name = undefined;
  exports.run = run;
  const name = exports.name = "ims/config";

  //check config and inform user if required ones are missing
  function run(conf, doc, cb) {

    var hadError = false;

    if (!check(conf.specTitle)) {
      (0, _pubsubhub.pub)("error", "head config must have the <code>specTitle</code> property set: " + "title of the document, excluding version");
      conf.specTitle = "@@@FIXME (conf.specTitle)";
      hadError == true;
    }

    if (!check(conf.specDate)) {
      (0, _pubsubhub.pub)("error", "head config must have the <code>specDate</code> property set, e.g. 'June 28, 2019'");
      conf.specDate = "@@@FIXME(conf.specDate)";
      hadError == true;
    }

    if (!check(conf.specNature)) {
      (0, _pubsubhub.pub)("error", "head config must have the <code>specNature</code> property set: one of 'normative' or 'informative'");
      conf.specNature = "informative";
      hadError == true;
    }

    if (!check(conf.specType)) {
      (0, _pubsubhub.pub)("error", "head config must have the <code>specType</code> property set: One of 'spec', 'cert', 'impl', 'errata', 'doc' ");
      conf.specType = "spec";
      hadError == true;
    }

    if (conf.specType === 'doc') return cb();

    if (!check(conf.shortName)) {
      (0, _pubsubhub.pub)("error", "head config must have the <code>shortName</code> property set: " + "list at urls-names.md#shortnames");
      conf.shortName = "FIXME";
      hadError == true;
    }

    if (!check(conf.specStatus)) {
      (0, _pubsubhub.pub)("error", "head config must have the <code>specStatus</code> property set," + "one of 'IMS Base Document', 'IMS Candidate Final (Public)' or 'IMS Final Release'");
      conf.specStatus = "@@@FIXME(conf.specStatus)";
      hadError == true;
    }

    var statusValues = ["IMS Base Document", "IMS Candidate Final", "IMS Candidate Final Public", "IMS Final Release"];
    if (statusValues.indexOf(conf.specStatus) == -1) {
      (0, _pubsubhub.pub)("error", "head config must have the <code>specStatus</code> property set to" + "one of 'IMS Base Document', 'IMS Candidate Final', 'IMS Candidate Final Public' or 'IMS Final Release'");
      hadError == true;
    }

    if (!check(conf.specVersion)) {
      (0, _pubsubhub.pub)("error", "head config must have the <code>specVersion</code> property set, e.g. '1.1'");
      conf.specVersion = "@@@FIXME(conf.specVersion)";
      hadError == true;
    }

    cb();
  }

  function check(value) {
    return value != undefined && value.trim().length > 0;
  }
});
//# sourceMappingURL=config.js.map;
